/*
 * NicheCanvas — Alia guard: suppress Alia popups while the shopper is "in the cart"
 * (UpCart drawer open — detected via the .upcartPopupShow class in the shadow root —
 * or on the /cart page). CSS-hide only (html.nc-cart-open [id^="alia-root"]): the
 * popup is NOT closed/unmounted, so it simply reappears once the drawer closes —
 * no lost signups. The slow 1s interval is the close-detection safety net.
 */
(function () {
  'use strict';
  var STYLE_ID = 'nc-alia-guard';
  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = 'html.nc-cart-open [id^="alia-root"]{display:none !important;}';
    (document.head || document.documentElement).appendChild(st);
  }
  function inCart() {
    if ((location.pathname || '').indexOf('/cart') === 0) return true;
    var r = window.upcartDocumentOrShadowRoot;
    return !!(r && r.querySelector('.upcartPopupShow'));
  }
  var t = null;
  function apply() {
    ensureStyle();
    document.documentElement.classList.toggle('nc-cart-open', inCart());
  }
  function schedule() { clearTimeout(t); t = setTimeout(apply, 120); }
  function start() {
    var r = window.upcartDocumentOrShadowRoot; if (!r) return false;
    try { new MutationObserver(schedule).observe(r, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); } catch (e) {}
    ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartOpened'].forEach(function (fn) {
      if (typeof window[fn] === 'function') { try { window[fn](schedule); } catch (e) {} }
    });
    apply();
    return true;
  }
  var n = 0;
  var poll = setInterval(function () {
    if (window.upcartDocumentOrShadowRoot && start()) { clearInterval(poll); return; }
    if (++n > 100) clearInterval(poll);
  }, 300);
  setInterval(function () { if (document.getElementById(STYLE_ID)) apply(); }, 1000);
})();
